module.exports = __webpack_public_path__ + "assets/8a467547a9472f144bf17a179ed43974.png";